import multiguard from 'vue-router-multiguard';

import Home from '@/views/Home.vue'
import Features from '@/views/Features.vue'
import Map from '@/views/Map.vue'
import Chasers from '@/views/Chasers'
import ChasersProfile from '@/views/ChaserProfile/Page'
import Discover from '@/views/Discover/Discover'
// import WallView from '@/views/WallView'
import ChatViewOld from '@/views/ChatViewOld'
import AuthDisabled from '@/views/Auth/TemporarilyDisabled.vue'

import StreamView from '@/views/ProtectedStream/StreamView.vue'

// Auth
import AuthLayoutView from '@/views/Auth/Layout.vue'
import LoginView from '@/views/Auth/Login.vue'
import RegisterView from '@/views/Auth/Register.vue'

import PrivacyPolicy from '@/views/PrivacyPolicy'

// Blog
import Blog from '@/views/Blog'
import ExampleBlogPost from '@/views/ExampleBlogPost'

import Guard from '@/router/middleware';

export default [
    {
        path: '/',
        name: 'Home',
        component: Map,
        beforeEnter: multiguard([Guard.checkAuth]),
    },
    {
        path: '/features',
        name: 'Features',
        component: Features
    },
    {
        path: '/map',
        name: 'Map',
        component: Map,
        redirect: '/'
    },
    //     {
    //         path: '/discover',
    //         name: 'Discover',
    //         component: Discover,
    //         beforeEnter: multiguard([Guard.checkAuth]),
    //     },
    {
        path: '/chasers',
        name: 'Chasers',
        component: Chasers
    },
    {
        path: '/chasers/:profile',
        name: 'ChasersProfile',
        component: ChasersProfile,
        beforeEnter: multiguard([Guard.checkAuth]),
    },
    {
        path: '/stream/:profile',
        redirect: '/chasers/:profile'
    },
    {
        path: '/chasers/:profile/media',
        name: 'ChasersProtectedStream',
        component: StreamView,
    },
    {
        path: '/auth/login',
        // component: LoginView,
        // name: 'LoginView'
        redirect: '/auth/disabled'
    },
    {
        path: '/auth/register',
        component: RegisterView,
        name: 'RegisterView',
        redirect: '/auth/disabled'
    },
    {
        path: '/auth/disabled',
        component: AuthDisabled,
        name: 'AuthDisabled',
    },
    {
        path: '/blog',
        name: 'Blog',
        component: Blog
    },
    {
        path: '/blog/relaunch-the-storm-awaits',
        name: 'ExampleBlogPost',
        component: ExampleBlogPost
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy
    },
    {
        path: '/comingsoon',
        redirect: '/blog/relaunch-the-storm-awaits'
    },
    // {
    //     path: '/protected/wall',
    //     component: WallView,
    //     name: 'WallView'
    // },
    {
        path: '/stream/:chaserId/chat',
        component: ChatViewOld,
        name: 'ChatViewOld'
    },
    {
        path: '/stream/:streamId/chat',
        component: ChatViewOld,
        name: 'ChatViewOld'
    }


]
